import {Injectable} from '@angular/core';
import {ApiImplementation} from '../api/api-implementation.service';
import {ApiService} from '../api/api.service';
import {Paginator} from '../../models/paginator';
import {Employee} from '../../models/employee';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService extends ApiImplementation {

  protected base: string       = "v1/employees";
  protected primaryKey: string = "id";

  constructor(protected api: ApiService) {
    super(api)
  }

  model(data?) {
    return new Employee(data);
  }

  paginator(data) {
    return new Paginator<Employee>(data);
  }


  public all(limit = 100, page = 1): Promise<Paginator<Employee>> {
    return super.all(limit, page) as Promise<Paginator<Employee>>;
  }

  public get(id: number) {
    return super.get(id) as Promise<Employee>;
  }

  public delete(employee: Employee) {
    return super.delete(employee);
  }

  public save(employee: Employee): Promise<Employee> {
    return super.save(employee) as Promise<Employee>;
  }


}
